<template>
<!-- 商品管理 -->
    <div class="el-card pd20">
        <div class="main">
            <div class="box">
                <!--  --> 
                <div class="search">
                    <div class="search-gropu">
                        测评
                        <el-select class="search-child" v-model="obj" @change="CepingChange" value-key="cid"  placeholder="请选择测评" clearable>
                            <el-option v-for="item in CepingArr" :key="item.cid"  :label="item.name" :value="item"></el-option>
                        </el-select>
                    </div>
                    <!-- <div class="search-gropu">
                        <label >用户昵称：</label>
                        <el-input class="input" v-model="nickname" placeholder="请输入用户昵称"></el-input>
                    </div> -->
                    <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                </div>
            
            </div>
            <!-- list-->
            <div class="el-card pd20">
                <div class="statistics-box">
                    <div class="statis-child on">
                        <div class="top">
                            <h4>{{info.today_subscribe_count}}</h4>
                            <p>今日关注人数</p>
                        </div>
                        <div class="bottom">
                            <div class="box">
                                <h5>{{info.today_unsubscribe_count}}</h5>
                                <p>今日取关人数</p>
                            </div>
                            <div class="box">
                                <h5>{{info.today_real_subscribe_count}}</h5>
                                <p>今日净关人数</p>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="statis-child on">
                        <div class="top">
                            <h4>{{info.today_scan_count}}</h4>
                            <p>今日扫码人数</p>
                        </div>
                        <div class="bottom">
                            <div class="box">
                                <h5>{{info.today_scan_count_new}}</h5>
                                <p>新用户</p>
                            </div>
                            <div class="box">
                                <h5>{{info.today_scan_count_old}}</h5>
                                <p>老用户</p>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="statis-child">
                        <div class="top">
                            <h4>{{info.total_scan_count}}</h4>
                            <p>总扫码人数</p>
                        </div>
                        <div class="bottom">
                            <div class="box">
                                <h5>{{info.total_scan_count_new}}</h5>
                                <p>新用户</p>
                            </div>
                            <div class="box">
                                <h5>{{info.total_scan_count_old}}</h5>
                                <p>老用户</p>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="statis-child">
                        <div class="top">
                            <h4>{{info.total_subscribe_count}}</h4>
                            <p>总关注人数</p>
                        </div>
                        <div class="bottom">
                            <div class="box">
                                <h5>{{info.total_unsubscribe_count}}</h5>
                                <p>总取关人数</p>
                            </div>
                            <div class="box">
                                <h5>{{info.total_real_subscribe_count}}</h5>
                                <p>总净关人数</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { scanInfo,scanOptions} from "@/api/measurement";
export default {
    data() {
        return{
            info: {},
            nickname:'',
            event_key:'',
            obj:{},
            CepingArr:[]
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 改变测评选项时触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-27 11:45:45
        */
        CepingChange(val){
            this.obj = val;
        },
        pullData(){
            this.$showLoading();
            let obj = {};
            // 判断如果有值为真的情况下传参,否则不传
            if(Object.keys(this.obj) && Object.keys(this.obj).length>0){
                obj['cid'] = this.obj.cid;
                obj['event_key'] = this.obj.event_key;
            }else if(this.CepingArr.length>0){
                obj['cid'] = this.CepingArr[0].cid;
                obj['event_key'] = this.CepingArr[0].event_key;
                // 赋值给搜索对象
                this.obj = this.CepingArr[0];
            }
            scanInfo(obj).then((data)=>{
                if(data.error >0){
                    this.$hideLoading();
                    this.$message(data.msg);
                    return
                }
                this.info = data.info;
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            
        },
        // 获取全部测评
        getCeping(){
            // 获取全部测评
            scanOptions().then((data)=>{
                if(data.error>0){
                    this.$message(data.msg);
                    return
                }
                this.CepingArr = data.options;
                this.pullData();
            });
        }
    },
    created(){
        this.getCeping();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}

.statistics-box{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    // width: 100%;
    .statis-child{
        display: flex;
        flex-direction: column;
        align-content: center;
        box-shadow:  0 3px 12px #999999;
        border-radius: 15px;
        margin-left: 20px;
        background-color: #ffffff;
        &:first-child{
            margin-left: 0;
        }
        // width: 50%;
        flex: 1;
        .top{
            text-align: center;
            border-bottom: 1px solid #eeeeee;
            padding: 10px;
            h4{
                font-size: 20px;
                margin: 0 auto 15px;
                color:#25b864 ;
            }
            p{
                font-size: 14px;
                margin: 0;
                color: #666666;
            }
        }
        .bottom{
            display: flex;
            justify-content: center;
            .box{
                padding: 15px;
                flex: 1;
                text-align: center;
                h5{
                    font-size: 18px;
                    margin: 0 auto 8px;
                }
                p{
                    font-size: 14px;
                    margin: 0;
                    color: #666666;
                }
            }
        }
    }
    .statis-child.on{
        // margin-bottom: 20px;
    }
}

.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.el-input{
    width:200px;
}
</style>